// imports
import { unity } from '../Icons/unity';
import { cpp as cppIcon } from '../Icons/cpp';
import { stack } from 'react-icons-kit/icomoon/stack';
import { android } from 'react-icons-kit/icomoon/android';
import { appleinc } from 'react-icons-kit/icomoon/appleinc';
import { socialJavascript } from 'react-icons-kit/ionicons/socialJavascript';

// globals
const cs = {
  icon: unity,
  language: 'cs',
  code: `// initialize fizz
IFizzClient fizzClient = new FizzClient("YOUR-APP-ID", "YOUR-APP-SECRET");

// add listener
fizzClient.Chat.Listener.OnMessagePublished += (message) => {
  // messages received will be notified here
};

// open connection and send message
fizzClient.Open("userId", FizzLanguageCode.English, FizzServices.All, (openEx) => {
  if (openEx == null) {
    Dictionary<string, string> data;
    bool translate = true, persist = true, filter = true;

    fizzClient.Chat.PublishMessage("channelId", "userNick", "msgText", 
      data, translate, filter, persist, (publishError) => { });
  }
});`
};

const objC = {
  icon: { ...appleinc, id: 'iOS' },
  language: 'objectivec',
  code: `// initialize fizz
FizzClient *fizzClient = [FizzClient instance];
[fizzClient initializeWithAppId:@"YOUR-APP-ID" andSecret:@"YOUR-APP-Secret"];

// add listener
__weak YourViewController *wself = self;
[fizzClient.chat addListener:wself forKey:@"Your Custom Key for Listener"];

// delegate methods - FizzChannelMessageListener
-(void)onMessagePublishedEventReceived:(FizzChannelMessage *)message {
  // messages received will be notified here
}

// open connection and send message
[fizzClient openWithUser:@"userId" locale:English services:All andErrorAck:^(FizzError *openError) {
  [fizzClient.chat publishMessageToChannel:@"channelId" withNick:@"userNick" body:@"msgText"
    data:@{} translate:YES persist:YES filter:YES andErrorAck:^(FizzError *publishError) {
  }];
}];`
};

const java = {
  icon: android,
  language: 'java',
  code: `// initialize fizz
IFizzClient fizzClient = new FizzClient("YOUR-APP-ID", "YOUR-APP-SECRET");

// add listener
fizzClient.chat().listener().onMessagePublished(message -> {
  // messages received will be notified here
});

// open connection and send message
fizzClient.open("userId", FizzLanguageCode.English, FizzServices.All, openEx -> {
  if (openEx == null) {
    Map<String, String> data;
    boolean translate = true, persist = true, filter = true;
    
    fizzClient.chat().publishMessage("channelId", "userNick", "msgText",
      data, translate, filter, persist, publishError -> { });
  }
});`
};

const js = {
  icon: socialJavascript,
  language: 'javascript',
  code: `// initialize fizz
const fizzClient = FizzClient.init("YOUR-APP-ID", "YOUR-APP-Secret");

// add listener
fizzClient.chat.on('messagePublished', (fizzChannelMessage) => {
  // messages received will be notified here
});

// open connection and send message
fizzClient.open("userId", FizzLanguageCodes.English, FizzServices.All, (openError) => {
  const msgParams = {
    to: "channelId", nick: "userNick", body: "msgText",
    data: "any user defined string representation for meta",
    translate:true, persist:true, filter:true
  };
  fizzClient.chat.publishMessage(msgParams, (publishError) => {});
});`
};

const cpp = {
  icon: { ...cppIcon, id: 'cpp' },
  language: 'cpp',
  code: `// initialize fizz
IFizzClient fizzClient = IFizzClient::instance();
fizzClient.init("YOUR-APP-ID", "YOUR-APP-Secret",
  "writablePath to keep session logs required by fizz c++ client");

// add listener
fizzClient.chat()->listener()->addOnMessagePublishedListener([=](FizzChannelMessagePtr message) {
  // messages received will be notified here
}, "Your Custom Key for Listener");

// open connection and send message
fizzClient.open("userId", FizzLanguageCodes.English, FizzServices.All, [=](IFizzErrorPtr openError) {
  std::map<std::string, std::string> dataMap;
  bool translate = true, persist = true, filter = true;

  fizzClient.chat()->publishMessage("channelId", "userNick", "msgText",
    dataMap, translate, persist, filter, [=](IFizzErrorPtr publishError) {
  });
});`
};

const platform = {
  icon: stack,
  language: 'bash',
  code: `## credentials
# APP_ID="751326fc-305b-4aef-950a-074c9a21d461"
# APP_SECRET="5c963d03-64e6-439a-b2a9-31db60dd0b34"

## Get Session Token
curl -X POST \\
  https://api.fizz.io/v1/sessions \\
  -H 'Content-Type: application/json' \\
  -H 'Authorization: HMAC-SHA256 tXU3by4B2nevlMjcGtRrqIpVvg2ijG4ezr38GYqa8Kg=' \\
  -d '{
    "locale": "en",
    "user_id": "UserA",
    "app_id": "751326fc-305b-4aef-950a-074c9a21d461"
  }'
### Note: "tXU3by4B2nevlMjcGtRrqIpVvg2ijG4ezr38GYqa8Kg=" is "hmac SHA256 base64" of request body.

## Publish Message In Channel
curl -X POST \\
  https://api.fizz.io/v1/channels/global-sample/messages \\
  -H 'Content-Type: application/json' \\
  -H 'Session-Token: 0f1e956e299a11caea994994cb1e05a5' \\
  -d '{
  "persist": false,
  "nick": "user_a",
  "body": "Hello this is a test message"
}'
### Note: replace '0f1e956e299a11caea994994cb1e05a5' with "Session Token" response token.`
};

// exported data
const data = {
  codeSnippets: {
    'Unity / .NET': cs,
    'iOS SDK': objC,
    'Android SDK': java,
    'JavaScript': js,
    'C++': cpp,
    'Platform API': platform
  }
};

// exports
export default data;